import {
    ReactElement,
    HTMLAttributes
} from "react";
import { SearchNormal } from "../../assets";
import { Button } from "./button";

interface Props extends HTMLAttributes<HTMLElement> {
    str: string;
    search?: any;
    myStyle?: string;
    placeholder:string;
    onClick?: any;
    buttonTitle:string;
    loadingContent?:boolean;
}

export function SearchInput({ str, search, myStyle, onClick , placeholder  ,buttonTitle , loadingContent}: Props): ReactElement {
    return (
        <div className={`search-input ${myStyle && myStyle}`}>

{loadingContent ? <div className="w-100 search-content-loading content-loading"></div> :
            <>
            <img src={SearchNormal} alt="هامرز" className="search-icon" />
            <input
            placeholder={placeholder}
            value={str}
            onChange={(event) => {
                //if ((event.target.value).length > 2) {
                    search(event.target.value)
                    //}
                }}
                />
            <Button onClick={onClick} title={buttonTitle} myStyle="search-btn" />
            </>
}
        </div>
    )
}

export default SearchInput;